import React from "react";
import Checkout from "../components/Checkout";
import BreadcrumbTwo from "../components/BreadcrumbTwo";
import Contact from "../components/Contact";

const CheckoutPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Contact" />
      <Contact />
    </>
  );
};

export default CheckoutPage;